import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CommunityBoardGoodRegasyncReqPros, CommunityBoardGoodRegInitialState } from "../model/CommunityBoardGoodRegReducerType";

const reducerId = "CommunityBoardGoodRegReducer/asyncReqCommunityBoardGoodReg";
const controllerMap = new Map();

const initialState: CommunityBoardGoodRegInitialState = {
    status: "",
    n4ErrorCode: 0,
    strErrorMessage: "",
    isSuccess: false
};

const slice = createSlice({
    name: "CommunityBoardGoodRegReducer",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(asyncReqCommunityBoardGoodReg.pending, (state) => {
            state.status = "LOADING";
        });
        builder.addCase(asyncReqCommunityBoardGoodReg.fulfilled, (state, action) => {
            state.status = "COMPLETE";
            state.n4ErrorCode = action.payload.n4ErrorCode;
            state.strErrorMessage = action.payload.strErrorMessage;
            state.isSuccess = action.payload.isSuccess;
        });
        builder.addCase(asyncReqCommunityBoardGoodReg.rejected, (state, action) => {
            if (action.payload?.aborted) return; // 'AbortError'로 인한 취소라면 상태 변경하지 않음
            state.status = "FAIL";
        });
    }
});

type RejectPayload = { aborted: boolean; message?: string };

export const asyncReqCommunityBoardGoodReg = createAsyncThunk<
        any, // 성공 시 반환 타입 (API 응답 타입)
        CommunityBoardGoodRegasyncReqPros, // thunk 파라미터 타입
        {
            rejectValue: RejectPayload; // ❗ rejectWithValue 타입 명시
        }
    >(
    reducerId,
    async ({ board_seq }: CommunityBoardGoodRegasyncReqPros, thunkAPI) => {
        // 이전 요청이 있으면 취소
        const prevController = controllerMap.get(reducerId);
        if (prevController) prevController.abort();

        // 새 요청용 controller 생성
        const controller = new AbortController();
        controllerMap.set(reducerId, controller);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_DOMAIN}/ApiReact/CommunityBoardGoodReg.aspx?board_seq=${encodeURIComponent(board_seq)}`,
                {
                    signal: controller.signal,
                }
            );
            const data = await res.json();
            return data;
        }
        catch (error: any) {
            // ❗ AbortError인 경우는 구분해서 처리
            if (error.name === "AbortError") {
                return thunkAPI.rejectWithValue({ aborted: true });
            }
            return thunkAPI.rejectWithValue({ aborted: false, message: error.message });
        }
    }
);

export const CommunityBoardGoodRegActions = slice.actions;
export default slice.reducer;